import { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";

function CarsListPage() {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searching, setSearching] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  const sellerType = queryParams.get("sellerType");
  const condition = queryParams.get("condition");
  const type = queryParams.get("type");
  const purpose = queryParams.get("purpose");
  const search = queryParams.get("search") || "";

  // ✅ Fetch cars from backend
  useEffect(() => {
    const fetchCars = async () => {
      setLoading(true);
      try {
        // let url = "http://localhost:5000/cars";
          let url = `${process.env.REACT_APP_API_URL}/cars`;
        const params = [];

        if (sellerType) params.push(`sellerType=${encodeURIComponent(sellerType)}`);
        if (condition) params.push(`condition=${encodeURIComponent(condition)}`);
        if (type) params.push(`type=${encodeURIComponent(type)}`);
        if (purpose) params.push(`purpose=${encodeURIComponent(purpose)}`);

        if (params.length > 0) {
          url += `?${params.join("&")}`;
        }

        const res = await axios.get(url);
        let fetchedCars = res.data;

        // ✅ special handling for "used"
        if (condition === "used") {
          fetchedCars = fetchedCars.filter(
            (car) =>
              car.condition === "Foreign Used" || car.condition === "Local Used"
          );
        }

        setCars(fetchedCars);
      } catch (err) {
        console.error("Error fetching cars:", err);
        setCars([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCars();
  }, [sellerType, condition, type, purpose]);

  // ✅ Apply local search filter
  const filteredCars = cars.filter((car) => {
    const query = search.toLowerCase();
    return (
      car.title?.toLowerCase().includes(query) ||
      car.brand?.toLowerCase().includes(query) ||
      car.model?.toLowerCase().includes(query) ||
      car.fuel?.toLowerCase().includes(query)
    );
  });

  // ✅ handle search input change
  const handleSearchChange = (e) => {
    const newSearch = e.target.value;
    setSearching(true);
    queryParams.set("search", newSearch);
    navigate(`?${queryParams.toString()}`);

    // small delay to simulate searching
    setTimeout(() => setSearching(false), 400);
  };

    if (loading)
    return (
      <div className="container loading">
        <p className="p-3 text-center">⏳ Loading cars...</p>
      </div>
    );


  return (
    <div className="container Detail">
      <h2 className="mb-3">
        {condition
          ? `${condition.replace("-", " ")} Cars`
          : type
          ? `${type} Cars`
          : purpose
          ? `${purpose} Cars`
          : sellerType
          ? `${sellerType} Cars`
          : "All Cars"}
      </h2>

      {/* 🔍 Search box */}
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search by title, brand, model, fuel..."
          value={search}
          onChange={handleSearchChange}
        />
      </div>

      {searching ? (
        <p>🔍 Searching cars...</p>
      ) : filteredCars.length === 0 ? (
        <p>No cars found.</p>
      ) : (
        <div className="row">
          {filteredCars.map((car) => {
            let imageSrc = "https://via.placeholder.com/130";
            try {
              const images = JSON.parse(car.images || "[]");
              if (images.length > 0) {
                imageSrc = `${process.env.REACT_APP_API_URL}${images[0]}`;
              }
            } catch (err) {
              console.error("Invalid JSON in car.images:", err);
            }

            return (
              <div key={car.id} className="col-6 col-md-3 mb-3 custom-col">
                <Link
                  to={`/cars/${car.slug}`}
                  style={{ textDecoration: "none", color: "inherit" }} 
                >
                  <div className="card h-100">
                    <img
                      src={imageSrc}
                      alt={car.title}
                      className="card-img-top"
                      style={{ height: "130px", objectFit: "cover" }}
                    />
                    <div className="card-body p-0" style={{ lineHeight: "1" }}>
                      <p
                        className="card-text mb-2"
                        style={{
                          fontSize: "10px",
                          color: "green",
                          fontWeight: "bold",
                        }}
                      >
                        ETB {Number(car.price).toLocaleString()}
                      </p>
                      <p className="card-title mb-1.5" style={{ fontSize: "10px" }}>
                        {car.title}
                      </p>
                      <p className="card-title mb-1" style={{ fontSize: "10px" }}>
                        {car.brand} {car.model}
                      </p>
                      <p className="card-title mb-1" style={{ fontSize: "10px" }}>
                        {car.transmission} | {car.fuel}
                      </p>
                      <p className="card-text mb-1" style={{ fontSize: "8px" }}>
                        {car.location}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default CarsListPage;

